import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationError, NavigationStart, ParamMap, Router } from '@angular/router';
import { AuthService } from 'src/app/@core/services/auth.service';
import { RedirectParameter } from '../../model/redirect-parameter.model';
import { NavegationService } from '../../services/navegation.service';


var misc: any = {
  sidebar_mini_active: true
};

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  standalone: false
})
export class NavbarComponent implements OnInit {
  private readonly sidenavStateKey = 'midas.sidenav.pinned';

  private getStoredSidenavState(): boolean {
    try {
      const rawValue = localStorage.getItem(this.sidenavStateKey);
      return rawValue === null ? true : rawValue === 'true';
    } catch {
      return true;
    }
  }

  private storeSidenavState(isPinned: boolean): void {
    try {
      localStorage.setItem(this.sidenavStateKey, String(isPinned));
    } catch {
      // Intentionally ignored: do not block UI if storage is unavailable.
    }
  }

  private applySidenavState(isPinned: boolean): void {
    const body = document.getElementsByTagName('body')[0];
    const sidenavTogglers = Array.from(document.getElementsByClassName('sidenav-toggler'));

    body.classList.remove('g-sidenav-pinned');
    body.classList.remove('g-sidenav-hidden');
    body.classList.remove('g-sidenav-show');

    if (isPinned) {
      body.classList.add('g-sidenav-pinned');
      sidenavTogglers.forEach(toggler => toggler.classList.add('active'));
    } else {
      body.classList.add('g-sidenav-hidden');
      sidenavTogglers.forEach(toggler => toggler.classList.remove('active'));
    }

    misc.sidebar_mini_active = isPinned;
  }

  onMouseEnterSidenav() {
    if (!document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.add("g-sidenav-show");
    }
  }
  onMouseLeaveSidenav() {
    if (!document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.remove("g-sidenav-show");
    }
  }
  minimizeSidebar() {
    const body = document.getElementsByTagName('body')[0];
    const isCurrentlyPinned = body.classList.contains('g-sidenav-pinned');
    const nextPinnedState = !isCurrentlyPinned;

    this.applySidenavState(nextPinnedState);
    this.storeSidenavState(nextPinnedState);
  }

  private access: Array<any> = [
    {
      nome: 'Cliente',
      url: 'customer',
      icone: 'fa fa-industry text-green',
      show: false,
      children: [
        {
          nome: 'Ativo',
          url: 'ativo',
          icone: 'ni-ui-04 text-info',
          active: true
        },
        {
          nome: 'Bloqueado',
          url: 'bloqueado',
          icone: 'ni-ui-04 text-info',
          active: true
        },
        {
          nome: 'Cancelado',
          url: 'cancelado',
          icone: 'ni-ui-04 text-info',
          active: true
        },
        {
          nome: 'Especial',
          url: 'especial',
          icone: 'ni-ui-04 text-info',
          active: true
        },
        {
          nome: 'Liberado',
          url: 'liberado',
          icone: 'ni-ui-04 text-info',
          active: true
        },
        {
          nome: 'Suspenso',
          url: 'suspenso',
          icone: 'ni-ui-04 text-info',
          active: true
        },
        {
          nome: 'Antecipado Bloqueado',
          url: 'antecipado-bloqueado',
          icone: 'ni-ui-04 text-info',
          active: true
        },
        {
          nome: 'Pré-ativo',
          url: 'preativo',
          icone: 'ni-ui-04 text-info',
          active: true
        },
        {
          nome: 'Inativo',
          url: 'inativo',
          icone: 'ni-ui-04 text-info',
          active: true
        },
        {
          nome: 'Todos',
          url: 'all',
          icone: 'ni-ui-04 text-info',
          active: true
        },
      ]
    },
    {
      nome: 'Cotação',
      url: 'quote',
      icone: 'ni-ruler-pencil text-info',
      show: false,
      children: [
        {
          nome: 'Cancelada',
          url: 'cancelada',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'CPE',
          url: 'cpe',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Excluída',
          url: 'excluida',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Expirada',
          url: 'expirada',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Ganha',
          url: 'ganha',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Ganha Parcial',
          url: 'ganhaparcial',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Pendente',
          url: 'pendente',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Perdida',
          url: 'perdida',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Rascunho',
          url: 'rascunho',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Todas',
          url: 'all',
          icone: 'ni-ui-04 text-info',
          active: false
        }
      ]
    }, {
      nome: 'Pedido',
      url: 'order',
      icone: 'fa fa-shopping-cart text-purple',
      show: false,
      children: [
        {
          nome: 'Aprovado',
          url: 'aprovado',
          icone: 'ni-ui-04 text-info',
          active: false
        }, {
          nome: 'Parcialmente Aprovado',
          url: 'parcialmenteaprovado',
          icone: 'ni-ui-04 text-info',
          active: false
        }, {
          nome: 'Bloqueado',
          url: 'bloqueado',
          icone: 'ni-ui-04 text-info',
          active: false
        }, {
          nome: 'Cancelado',
          url: 'cancelado',
          icone: 'ni-ui-04 text-info',
          active: false
        }, {
          nome: 'Devolvido',
          url: 'devolvido',
          icone: 'ni-ui-04 text-info',
          active: false
        }, {
          nome: 'Excluído',
          url: 'excluido',
          icone: 'ni-ui-04 text-info',
          active: false
        }, {
          nome: 'Rascunho',
          url: 'rascunho',
          icone: 'ni-ui-04 text-info',
          active: false
        }, {
          nome: 'Todos',
          url: 'all',
          icone: 'ni-ui-04 text-info',
          active: false
        },
      ]
    },
    {
      nome: 'Boleta',
      url: 'factory',
      icone: 'fa fa-list-alt text-brown',
      show: false,
      children: [
        {
          nome: 'Carteira de Pedidos',
          url: 'carteira',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Entregue',
          url: 'entregue',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Todos',
          url: 'all',
          icone: 'ni-ui-04 text-info',
          active: false
        }
      ]
    }, {
      nome: 'Faturamento',
      url: 'revenue',
      icone: 'ni-chart-pie-35 text-yellow',
      show: false,
      children: [
        {
          nome: 'Boleta Liberada',
          url: 'boleta-liberado',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Bloqueado',
          url: 'bloqueado',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Liberado',
          url: 'liberado',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Faturado',
          url: 'faturado',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Cancelado',
          url: 'cancelado',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Devolução',
          url: 'devolucao',
          icone: 'ni-ui-04 text-info',
          active: false
        }
      ]
    },
    {
      nome: 'Ordem de fabricação',
      url: 'manufacturing-order',
      icone: 'fa fa-barcode text-orange',
      show: false,
      children: [
        {
          nome: 'Em Produção',
          url: 'producao',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Finalizado',
          url: 'finalizado',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Transformado',
          url: 'transformado',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Rascunho',
          url: 'rascunho',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Rejeitado',
          url: 'rejeitado',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Cancelado',
          url: 'cancelado',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Todos',
          url: 'all',
          icone: 'ni-ui-04 text-info',
          active: false
        }
      ]
    },
    {
      nome: 'B.O.M',
      url: 'bom',
      icone: 'fa fa-list-ol text-red',
      show: false,
      children: [
        {
          nome: 'Todos',
          url: 'all',
          icone: 'ni-ui-04 text-info',
          active: false
        }
      ]
    },
    {
      nome: 'Drawback',
      url: 'drawback',
      icone: 'ni-money-coins text-orange',
      show: false,
      children: [
        {
          nome: 'Todos',
          url: 'all',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Rascunhos',
          url: 'draft',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Aprovados',
          url: 'approved',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Encerrados',
          url: 'finished',
          icone: 'ni-ui-04 text-info',
          active: false
        }
      ]
    },
    {
      nome: 'Requisição',
      url: 'request',
      icone: 'fa fa-retweet text-purple',
      show: false,
      children: [
        {
          nome: 'Aguardando atendimento',
          url: 'aguardando-atendimento',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Aguardando entrada (NFe)',
          url: 'aguardando-entrada-nfe',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Em andamento',
          url: 'em-andamento',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Finalizada',
          url: 'finalizada',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Semi-Devolvido',
          url: 'semi-devolvido',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Todas',
          url: 'all',
          icone: 'ni-ui-04 text-info',
          active: false
        }
      ]
    },
    {
      nome: 'Contrato',
      url: 'contract',
      icone: 'fa fa-handshake text-blue',
      show: false,
      children: [
        {
          nome: 'Ativos',
          url: 'ativo',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Inativos',
          url: 'inativo',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Rascunho',
          url: 'rascunho',
          icone: 'ni-ui-04 text-info',
          active: true
        },
        {
          nome: 'Todos',
          url: 'all',
          icone: 'ni-ui-04 text-info',
          active: false
        }
      ]
    },
    {
      nome: 'Romaneio',
      url: 'packing-list',
      icone: 'ni-paper-diploma text-warning',
      show: false,
      children: [
        {
          nome: 'Todos',
          url: 'all',
          icone: 'ni-ui-04 text-info',
          active: false
        }
      ]
    },
    {
      nome: 'Solicitação de Coleta',
      url: 'collection-request',
      icone: 'ni-delivery-fast text-success',
      show: false,
      children: [
        {
          nome: 'Todos',
          url: 'all',
          icone: 'ni-ui-04 text-info',
          active: false
        }
      ]
    },
    {
      nome: 'Packing',
      url: 'packing',
      icone: 'ni-box-2 text-dark-gray',
      show: false,
      children: [
        {
          nome: 'Todos',
          url: '2',
          icone: 'ni-ui-04 text-info',
          active: false
        }/*,
        {
          nome: 'Liberados para faturamento',
          url: '3',
          icone: 'ni-ui-04 text-info',
          active: false
        }*/,
        {
          nome: 'Consolidar Embalagens',
          url: 'consolidate',
          icone: 'ni-ui-04 text-info',
          active: false
        }
      ]
    },
    {
      nome: 'Documentação ME',
      url: 'document-export',
      icone: 'fa fa-plane text-green',
      show: false,
      children: [
        {
          nome: 'Todos',
          url: 'all',
          icone: 'ni-ui-04 text-info',
          active: false
        }
      ]
    },
    {
      nome: 'Relatório de Visitas',
      url: 'visit-report',
      icone: 'fa fa-map-marker text-yellow',
      show: false,
      children: [
        {
          nome: 'Todos',
          url: 'all',
          icone: 'ni-ui-04 text-info',
          active: false
        }
      ]
    },
    {
      nome: 'Recebimento',
      url: 'receiving',
      icone: 'fa fa-truck text-info',
      show: false,
      children: [
        {
          nome: 'Novo',
          url: 'all',
          icone: 'ni-ui-04 text-info',
          active: true
        }
      ]
    },
    {
      nome: 'Certificado',
      url: 'conformity-certificate',
      icone: 'fa fa-certificate text-info',
      show: false,
      children: [
        {
          nome: 'Todos',
          url: 'all',
          icone: 'ni-ui-04 text-info',
          active: true
        }
      ]
    },
    {
      nome: 'Portal de Pedidos',
      url: 'teadit-store',
      icone: 'ni ni-shop text-dark-gray',
      show: false,
      children: [
        {
          nome: 'Usuários',
          url: 'user',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Tickets',
          url: 'ticket',
          icone: 'ni-ui-04 text-info',
          active: false
        },
        {
          nome: 'Imagens',
          url: 'images',
          icone: 'ni-ui-04 text-info',
          active: false
        }
      ]
    },
    {
      nome: 'Oportunidade',
      url: 'opportunity',
      icone: 'fa fa-hand-holding-usd text-blue',
      show: false,
      children: [
        {
          nome: 'Aprovado',
          url: 'aprovado',
          icone: 'ni-ui-04 text-info',
          active: true
        }, {
          nome: 'Cancelado',
          url: 'cancelado',
          icone: 'ni-ui-04 text-info',
          active: true
        }, {
          nome: 'Rascunho',
          url: 'rascunho',
          icone: 'ni-ui-04 text-info',
          active: true
        }, {
          nome: 'Todos',
          url: 'all',
          icone: 'ni-ui-04 text-info',
          active: true
        },
      ]
    }
  ];

  public isHomepage: boolean = false;
  public isLogin: boolean = false;
  public modulos: Array<any> = [];

  public urlMarket: string;
  public urlCompany: string;
  public urlModule: string;
  public urlCompanyGroup: string;
  public urlVisibility: string;
  public urlLineOfProduction: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private navegationService: NavegationService,
    private authService: AuthService
  ) {

  }

  ngOnInit(): void {

    this.router.events.subscribe(
      (event: any) => {
        if (event instanceof NavigationEnd) {
          this.isLogin = this.router.url === "/login";
          this.isHomepage = this.router.url === "/";

          if (this.isLogin || this.isHomepage || window.innerWidth < 900) {
            this.applySidenavState(false);
          } else {
            this.applySidenavState(this.getStoredSidenavState());
          }
        }
      }
    );

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.access.forEach(element => {
          let _urlMenu = `/${element.url}`;
          let _urllength = _urlMenu.length;
          if (event.url.substring(0, _urllength) === _urlMenu)
            element.show = true;
          else
            element.show = false;
        });
      }
    });

    if (window.innerWidth < 900) {
      this.applySidenavState(false);
    } else {
      this.applySidenavState(this.getStoredSidenavState());
    }

    this.setAccess();
    this.authService.valueSelected.subscribe(res => this.setAccess())

    this.route.params.subscribe(params => {

      this.modulos.forEach(modulo => {
        modulo.show = false
        modulo.children.forEach(child => child.active = false);
      });

      var _params = this.router.url.split('/');
      this.modulos.forEach(modulo => {
        if (_params.find(x => x === modulo.url) !== undefined) {
          setTimeout(() => {
            document.getElementById(modulo.url).style.backgroundColor = '#eeeeee';
          }, 200);
          modulo['show'] = true;
          modulo.children.forEach(child => {
            if (params['status'] === child.url)
              child.active = true;
          });
        }
      });
    });

    this.route.paramMap.subscribe((params: ParamMap) => {
      if (params.get('market') != null && params.get('market') != "undefined")
        this.urlMarket = params.get('market');

      if (params.get('company') != null && params.get('company') != "undefined")
        this.urlCompany = params.get('company');

      if (params.get('company-group') != null && params.get('company-group') != "undefined")
        this.urlCompanyGroup = params.get('company-group');

      if (params.get('visibility') != null && params.get('visibility') != "undefined")
        this.urlVisibility = params.get('visibility');

      if (params.get('lineOfProduction') != null && params.get('lineOfProduction') != "undefined")
        this.urlLineOfProduction = params.get('lineOfProduction');
    });

    let _modulo = this.modulos.find(modulo => modulo.url === this.router.url.substring(1, this.router.url.length));
    if (_modulo !== undefined)
      _modulo.show = true;
  }

  setAccess(): void {
    this.modulos = [];

    if (this.authService.getClaims() !== undefined && this.authService.getClaims() !== null) {
      let _modules = this.authService.getClaims().Modules;
      _modules.forEach(module => {
        let _module = this.access.find(x => x.url == module.ModuleId);
        if (_module !== undefined)
          this.modulos.push(_module);
      });
    }
  }

  show(item): void {
    if (this.modulos[item]['show']) {
      this.modulos.forEach(modulo => modulo.show = false);
    } else {
      this.modulos.forEach(modulo => modulo.show = false);
      this.modulos[item]['show'] = true;
    }
  }

  status(modulo, status) {
    this.navegationService.addParameter(modulo, new RedirectParameter("status", status));
    this.navegationService.addParameter(modulo, new RedirectParameter("module", status));

    if (this.urlCompany != null && this.urlCompany != "undefined")
      this.navegationService.addParameter(modulo, new RedirectParameter("company", this.urlCompany));

    if (this.urlCompanyGroup != null && this.urlCompanyGroup != "undefined")
      this.navegationService.addParameter(modulo, new RedirectParameter("company-group", this.urlCompanyGroup));

    switch (modulo) {
      case "quote":
      case "order":
        if (this.urlMarket != null && this.urlMarket != "undefined")
          this.navegationService.addParameter(modulo, new RedirectParameter("market", this.urlMarket));

        if (this.urlVisibility != null && this.urlVisibility != "undefined")
          this.navegationService.addParameter(modulo, new RedirectParameter("visibility", this.urlVisibility));
        break;
      case "manufacturing-order":
      case "factory":
        if (this.urlLineOfProduction != null && this.urlLineOfProduction != "undefined")
          this.navegationService.addParameter(modulo, new RedirectParameter("lineOfProduction", this.urlLineOfProduction));
        break;
    }
    this.navegationService.redirect();
  }

}
